<template>
    <div class="at-message at-deletemsg">
      <h5 v-if="!messageProps.isSender && messageProps.chatType == 2 ">{{messageProps.userName}}</h5>
      <div class="at-del-msg"><i class="guppy-slash"></i> {{TRANS.deleted_message}}</div>
    </div>
</template>

<script>
export default {
  name: "GuppyDeleteMessage",
  props:['messageProps'],
};
</script>